import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

function PageHeader({ title, children, hasBackButton = false }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <Header>
      {/* Left side (Back + Title) */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {hasBackButton && (
          <ArrowLeftOutlined
            onClick={handleBack}
            style={{ fontSize: 18, cursor: "pointer", color: "#1565c0" }}
          />
        )}
        <Title>{title}</Title>
      </div>

      {/* Right side (Actions) */}
      <Actions>{children}</Actions>
    </Header>
  );
}

export default PageHeader;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 10px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1565c0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;